import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SFIcon, SFIconButton } from 'sfui';
import styles from './SupportContent.module.scss';

export interface SupportContentProps {
  section: string;
  title: string;
  children: React.ReactNode;
}

export const SupportContent = ({
  section,
  title,
  children
}: SupportContentProps): React.ReactElement<SupportContentProps> => {
  const navigate = useNavigate();

  const onBack = () => navigate(-1);

  return (
    <div className={styles.supportContent}>
      <h1 className={styles.title}>Support</h1>

      <div className={styles.navBar}>
        <SFIconButton
          sfIcon="Left-7"
          iconSize="large"
          buttonSize="medium"
          onClick={onBack}
          aria-label="Back"
        />

        <div className={styles.breadcrumb}>
          <h2 className={styles.breadcrumbSection}>{section}</h2>
          <SFIcon icon="Right-2" size={16} />
          <h2 className={styles.breadcrumbTitle}>{title}</h2>
        </div>
      </div>

      <div className={styles.content}>{children}</div>
    </div>
  );
};
